import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import Navbar from './components/Navbar';
import GrainOverlay from './components/GrainOverlay';
import Footer from './components/Footer';
import Home from './pages/Home';
import Work from './pages/Work';
import Info from './pages/Info';
import './App.css';

function AnimatedPage({ children }) {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4, ease: 'easeInOut' }}
        >
            {children}
        </motion.div>
    );
}

function App() {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className="App">
            <GrainOverlay />
            <Navbar />
            <main className="main-content">
                <AnimatePresence mode="wait">
                    <Routes location={location} key={location.pathname}>
                        <Route path="/" element={<AnimatedPage><Home /></AnimatedPage>} />
                        <Route path="/work" element={<AnimatedPage><Work /></AnimatedPage>} />
                        <Route path="/info" element={<AnimatedPage><Info /></AnimatedPage>} />
                    </Routes>
                </AnimatePresence>
            </main>
            <Footer />
        </div>
    );
}

export default App;
